import ApiServiceMasterHr from '../apiServiceMasterHr.js';

const querystring = require('querystring')
var VacationTemplateService = {

    findAll: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "vacationTemplates"
            $options.method = "get"

            if ($data) {
                $options.url = "vacationTemplates?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterHr.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    findOne: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "vacationTemplates/" + $data
            console.log($options.url)
            $options.method = "get"
            if (!$data) {
                $options.data = $data
            }
            ApiServiceMasterHr.request($options)
                .then(response => {
                    // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });

    },
    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "vacationTemplates/" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiServiceMasterHr.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        })
    },
    save: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "vacationTemplates" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiServiceMasterHr.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },

    create: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "vacationTemplates";
            $options.method = "post"
            console.log($options)
            ApiServiceMasterHr.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    }
};
export default VacationTemplateService;